import styled from "styled-components";


export const FlexCronograma = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
    gap: 20px;
    row-gap: 20px;
    column-gap: 20px;
    flex-wrap: wrap;
    transition: all 0.2s ease;
    align-items: start;
`;

export const SpanHoraBrasilia = styled.span`
    font-size: 11px;
    color: ${({ theme }) => theme.colors.interfaceGray400};
    font-weight: 400;
    margin-top: 2px;
    padding-left: 10px;
    display: block;
    line-height: 1.4;
    margin-left: 0;
`;

export const DataWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    align-items: flex-start;
`;

export const InputContainer = styled.div`
    flex: 1;
    padding-left: 10px;
    
    .default-input {
        min-height: auto;
        margin-top: 0;
        
        input {
            height: 32px;
            padding: 6px 12px;
            margin-top: 0;
            font-size: 14px;
            border-radius: 6px;
            border: 1px solid ${(props: any) => props.theme.colors.interfaceText100};
            transition: border-color 0.2s ease;
            background: ${(props: any) => props.theme.colors.white};
            color: ${(props: any) => props.theme.colors.interfaceText500};
            
            &:hover {
                border: 1px solid ${(props: any) => props.theme.colors.c000000};
            }
            
            &:focus {
                border: 1px solid ${(props: any) => props.theme.colors.c000000};
                outline: none;
            }
        }
        
        &.error input {
            border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
            
            &:hover {
                border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
            }
            
            &:focus {
                border: 1px solid ${(props: any) => props.theme.colors.primaryRed400};
                outline: none;
            }
        }
    }
`;
